import React from "react";
import classnames from "classnames";

const PhoneSimulatorHeader = ({children, className}) => {

    return (
        <>
            <div className={classnames('phone-simulator-header', className)}>
                {children}
            </div>
        </>
    )
}

export default PhoneSimulatorHeader;
